export const WidgetButtonCoordinates = {
  bottom: 20,
  right: 20,
};

export const WidgetCoordinates = {
  bottom: WidgetButtonCoordinates.bottom + 64,
  right: WidgetButtonCoordinates.right,
  top: 20,
  left: 40,
};

// we're embedding a Svelte widget in an iframe on top of an unknown JS framework (e.g. React).
// `tick()` only waits for Svelte's updates, not full browser paint.
// This utility ensures the current JS stack clears and the next frame is painted.
export async function waitForDomFlush() {
  // let all JS run
  await new Promise((resolve) => setTimeout(resolve, 0));
  // let the browser render
  await new Promise(requestAnimationFrame);
}
